module.exports = __webpack_public_path__ + "static/img/bg_coupon_one.29b1162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_one.png
// module id = RK1b
// module chunks = 0